import React from 'react'
import { Box } from '@material-ui/core'

const ContentfulLoading = () => {
    return <Box>Fetching data from the CMS...</Box>
}

export default ContentfulLoading